import { matchPath } from 'react-router-dom'
import { dashboardRoutes, publicRoutes } from '../../setup/config'
import { pageTitleMapping, titles } from '../../setup/messages'
import { IGlobalState } from '../../setup/reducers'

export const getTitleByPath = (path: string, state?: IGlobalState): string => {
  if (path === publicRoutes.timeTracking) return titles.timeTracking
  for (const obj of Object.entries(dashboardRoutes)) {
    const route = obj[1]
    const isMatch = matchPath(path, route)
    if (isMatch) {
      return pageTitleMapping[route](state) || titles.dashboard
    }
  }
  return titles.dashboard
}
